import { Info } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const ComplianceDisclaimer = () => (
  <section className="py-10 bg-cream" data-testid="compliance-disclaimer-section">
    <div className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-10">
      <Reveal>
        <div className="flex items-start gap-3 rounded-xl border border-ink/10 bg-cream-alt p-5 sm:p-6">
          <Info size={18} className="text-ink-faint shrink-0 mt-0.5" />
          <p className="text-xs sm:text-sm text-ink-soft leading-relaxed">
            Ferguson's Custom Brokers operates in full compliance with applicable customs and border
            protection regulations in each jurisdiction we serve. Country-specific produce
            restrictions, controlled goods classifications, and permit requirements vary by trade
            lane. Our team will advise you on all applicable restrictions before your shipment is
            confirmed.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
